<template>
  <div class="save">
    <el-form ref="ruleForm" class="form" :model="form" label-width="3rem" :rules="rules" label-position="top">
        <el-form-item label="评估类型" prop="AssessmentType">
          <el-select v-model="form.AssessmentType" placeholder="请选择评估类型" @change="getAssessmentScale" style="width:100%">
            <el-option v-for="(item , index) in assessmentType" :key="index" :label="item.Text" :value="item.Value" />
          </el-select>
        </el-form-item>
        <el-form-item label="评估量表" prop="AssessmentScale">
          <el-select v-model="form.AssessmentScale" :disabled="!form.AssessmentType" placeholder="请选择评估量表" style="width:100%">
            <el-option v-for="(item , index) in assessmentScale" :key="index" :label="item.Text" :value="item.Value" />
          </el-select>
        </el-form-item>
        <el-form-item label="长者选择" prop="AssessingElderlyId">
          <el-select v-model="form.AssessingElderlyId" filterable placeholder="请选择长者" style="width:100%">
            <el-option v-for="(item , index) in assessingElderly" :key="index" :label="item.name" :value="item.id" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <div class="submit" v-loading="loading" @click="onSubmit">保存</div>
        </el-form-item>
      </el-form>
  </div>
</template>

<script>

export default {
  // 组件参数 接收来自父组件的数据
  props: {},
  // 局部注册的组件

  // 组件状态值
  data () {
   return {
      activeName:'first',
      loading:false,
      form:{},
      assessmentType:[],
      assessmentScale:[],
      assessingElderly:[],
      rules: {
        AssessmentType: [{ required: true, message: '请选择评估类型', trigger: 'change' }],
        AssessmentScale: [{ required: true, message: '请选择评估量表', trigger: 'change' }],
        AssessingElderlyId: [{ required: true, message: '请选择长者', trigger: 'change' }]
      }
   }
  },
  created(){
    this.getAssessmentType()
    this.getAssessingElderly()
  },
  methods:{
    // tab切换
    handleClick(){

    },

    //获取评估类型
    getAssessmentType() {
        this.$axios.get("/Evaluate/AssessmentType").then((res) => {
            const data =res.data
            this.assessmentType = data.obj;
        })
    },

    //获取评估量表
    getAssessmentScale(type) {
        this.assessmentScale = []
        if (this.form.AssessmentScale) this.form.AssessmentScale = ''
        this.$axios.get("/Evaluate/AssessmentScale?type=" + type).then((res) => {
            const data =res.data
            this.assessmentScale = data.obj;
        })
    },

    //获取所有长者信息
    getAssessingElderly(type) {
        this.$axios.post("/Evaluate/AssessingElderly").then((res) => {
            const data =res.data
            this.assessingElderly = data.obj;
        })
    },

    //提交评估
    onSubmit() {
        this.$refs.ruleForm.validate(valid => {
            if (valid) {
                const userName = this.$store.state.user.UserName
                const form  = {...this.form,userName}
                const queryString = Object.keys(form).map(key => key + '=' + form[key]).join('&');
                this.loading = true
                this.$axios.post("/Evaluate/Initiate?"+queryString ).then((res) => {
                    this.loading = false
                    this.$message.success({
                      message:'保存成功',
                      offset: 100
                    });
                    this.$nextTick(() =>   this.$refs.ruleForm.clearValidate())
                    this.form = {}
                    this.$emit('changeTab')
                }).catch((err) => {
                    this.loading = false
                });
            }
        })

    },
  }

}
</script>

<style scoped>
.save  {
  height: 100%;
  background: #fff;
}
.form >>> .el-form-item__label  {
  padding: 0;
}
.form >>> .el-form-item  {
  margin-bottom: 10px;
}
.form {
  padding:0 16px;
}

.submit {
  width: 225px;
  height: 44px;
  line-height: 44px;
  text-align: center;
  margin: 0 auto;
  margin-top: 20px;
  border-radius: 24px;
  background: #029FD1;
  font-size: 16px;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/assessment/sava.vue